import { render, staticRenderFns } from "./LoginFastAccessModalCompletoLojista.vue?vue&type=template&id=6c5796ff"
import script from "./LoginFastAccessModalCompletoLojista.vue?vue&type=script&lang=js"
export * from "./LoginFastAccessModalCompletoLojista.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports